import Logger from "../../../core/internal/logger"
import { HackleApp } from "../HackleWebAppClient"

export enum InvocationChannel {
  prompt = "prompt",
  function = "function",
  message = "message"
}

export function resolveInvocationChannels(hackleApp: HackleApp): InvocationChannel[] {
  const fallbackChannels = [hackleApp.getInvocationType() as InvocationChannel]

  if (typeof hackleApp.getSupportedInvocationTypes !== "function") {
    return fallbackChannels
  }

  let parsedTypes: any
  try {
    parsedTypes = JSON.parse(hackleApp.getSupportedInvocationTypes())
  } catch (e) {
    Logger.log.debug(`Failed to resolve invocation channels: ${e}`)
    return fallbackChannels
  }

  if (!Array.isArray(parsedTypes)) {
    Logger.log.debug(`Invalid invocation channels format: ${JSON.stringify(parsedTypes)}`)
    return fallbackChannels
  }

  const knownChannels: readonly string[] = Object.values(InvocationChannel)
  const channels = parsedTypes.filter((it: any): it is InvocationChannel => knownChannels.indexOf(it) >= 0)
  if (channels.length === 0) {
    Logger.log.debug(`No known invocation channels. [channels=${JSON.stringify(parsedTypes)}]`)
    return fallbackChannels
  }

  return channels
}
